'use client';

type ConfirmButtonProps = {
    onClick: () => void;
    variant: 'cancel' | 'danger' | 'primary';
    children: React.ReactNode;
    disabled?: boolean;
    title?: string;
};

export default function ConfirmButton({ onClick, variant, children, disabled, title }: ConfirmButtonProps) {
    const baseClasses = 'px-3 py-1.5 rounded-md transition-colors font-cantarell text-xs';
    const variantClasses = {
        cancel: 'bg-color-ide-file-cancel-button hover:bg-color-ide-file-cancel-button-hover',
        danger: 'bg-color-ide-file-discard-button hover:bg-color-ide-file-discard-button-hover text-color-white-base',
        primary: 'bg-color-ide-file-save-button hover:bg-color-ide-file-save-button-hover text-color-white-base',
    };

    return (
        <button
            onClick={onClick}
            disabled={disabled}
            className={`${baseClasses} ${variantClasses[variant]} ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
            title={title}
        >
            {children}
        </button>
    );
}
